import { render, staticRenderFns } from "./Reset_password.vue?vue&type=template&id=0086a5a2&scoped=true&"
import script from "./Reset_password.vue?vue&type=script&lang=js&"
export * from "./Reset_password.vue?vue&type=script&lang=js&"
import style0 from "./Reset_password.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Reset_password.vue?vue&type=style&index=1&id=0086a5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086a5a2",
  null
  
)

export default component.exports